import { render } from "./BreakdownTable.vue?vue&type=template&id=5ee775d2"
import script from "./BreakdownTable.vue?vue&type=script&lang=js"
export * from "./BreakdownTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__